<div class="tab-group" *ngIf="!!tabpanels && tabpanels.toArray().length>0">
  <div class="tab-controls" role="tablist">
    <button *ngFor="let tab of tabpanels.toArray(); let i = index"
      [id]="hostId + '-tab-' + i"
      role="tab"
      [tabindex]="tab.isSelected ? '0': '-1'"
      class="tab-control"
      [ngClass]="{'selected-tab': tab.isSelected, 'mobile-max': tabpanels.toArray().length > 3}"
      [attr.aria-selected]="tab.isSelected"
      [attr.aria-controls]="hostId + '-tabpanel-' + i"
      (click)="clickEventListener($event, i)"
      (keydown)="keydownEventListener($event, i)"
      (keyup)="keyupEventListener($event, i)"
      #tabControl
    >
      <i *ngIf="tab.iconClass" aria-hidden="true" class="icons" [attr.class]="tab?.iconClass"></i>
      <i *ngIf="tab.iconPath" aria-hidden="true" class="icons">
        <img [cache]="tab?.iconPath" [lazyload]="tab?.iconPath" role="presentation" aria-hidden="true" alt="{{tab.navTitle}}">
      </i>
      <span [innerHTML]="tab.navTitle"></span>
    </button>
  </div>
  <div class="select-controls">
    <label for="mkt-dropdown-0">Select a topic and learn more</label>
    <div class="mkt-dropdown">
      <select #selectRef [value]="activeTab" id="mkt-dropdown-0"
        (change)="handleSelectValueChange($event)"
      >
        <option *ngFor="let option of tabpanels.toArray(); let i = index"
          [value]="i.toString()"
          [innerHTML]="option.navTitle"
        ></option>
      </select>
      <citi-icon2
        class="arrowIcon"
        name="02-down"
        shade="b2"
        aria-hidden="true"
        role="presentation"
      ></citi-icon2>
    </div>
  </div>

  <ng-content></ng-content>
</div>
